import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import PhoneInput from "react-phone-input-2";
import './Slideshow.css'; // CSS file for styling
import { useNavigate } from 'react-router-dom';
import CarFilter from '../Carlist/CarFiiltercomp'; // CarFilter component



import useCarFilter from '../Carlist/UseCarFilter'; // Custom hook for car filter logic


const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <div
            className={`${className} custom-arrow next-arrow`}
            style={{ ...style }}
            onClick={onClick}
        >
            ❯
        </div>
    );
};

const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <div
            className={`${className} custom-arrow prev-arrow`}
            style={{ ...style }}
            onClick={onClick}
        >
            ❮
        </div>
    );
};

const ImageSlider = () => {
    const navigate = useNavigate();
    const videoRef = useRef(null);
    const sliderRef = useRef(null);
    
    const {
        carMakes,
        carModels,
        carVariants,
        carColors,
        selectedMake,
        selectedModel,
        selectedVariant,
        selectedColor,
        handleMakeChange,
        handleModelChange,
        handleVariantChange,
        setSelectedColor,
        loading,
    } = useCarFilter(); // Custom hook to handle car filtering logic

    const [autoplay, setAutoplay] = useState(false);
    const [videoPlayed, setVideoPlayed] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);
    const [fadeInFilter, setFadeInFilter] = useState(false);
    const [animationKey, setAnimationKey] = useState(0);
    const [fadeInTitle, setFadeInTitle] = useState(false);
    const [fadeInForm, setFadeInForm] = useState(false); // New state for form animation

    useEffect(() => {
        // Trigger both animations when the component mounts
        const timer = setTimeout(() => {
            setFadeIn(true);
            setFadeInFilter(true);
            setFadeInTitle(true);
            setFadeInForm(true); // Trigger form fade-in
        }, 300); // Adjust delay as needed

        return () => clearTimeout(timer);
    }, [animationKey]);

    // Handle navigation to the /SellYourCar route
    const handleNext = () => {
        navigate('/SellYourCar');
    };

    // Video play logic
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible' && videoRef.current) {
                videoRef.current.play().catch((error) => {
                    console.log('Error attempting to play video:', error);
                });
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    const handleVideoEnd = () => {
        if (sliderRef.current) {
            sliderRef.current.slickNext(); // Move to the next slide
            sliderRef.current.slickPlay(); // Resume autoplay for other slides
            setAutoplay(true);
            setVideoPlayed(true); // Mark the video as played to hide it
        }
    };

    const handleBeforeChange = (current, next) => {
        if (next === 0 && !videoPlayed) {
            setAutoplay(false); // Disable autoplay for the video slide
            if (videoRef.current) {
                videoRef.current.play(); // Play the video when it's the first slide
            }
        }
    };
    const [loadings, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const handleAfterChange = (current) => {
        setFadeIn(false);
        setFadeInTitle(false);
        setFadeInForm(false); // Reset form animation
        setFadeInFilter(false);
        setAnimationKey(prevKey => prevKey + 1); // This will ensure the animation is re-triggered
        if (current === 0 && !videoPlayed) {
            setAutoplay(false);
            if (videoRef.current) {
                videoRef.current.play();
            }
        } else {
            setAutoplay(true); // Enable autoplay for other slides
        }
    };

    // Slider settings
    const settings = {
        dots: true,
        infinite: true,
        speed: 1000, // Increase speed for a smoother transition
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: autoplay, // Dynamically enable/disable autoplay
        autoplaySpeed: 3000, // Adjust the autoplay speed
        easing: 'ease-in-out', // Add easing for smoother transitions
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        beforeChange: handleBeforeChange, // Pause autoplay for the video
        afterChange: handleAfterChange, // Resume autoplay for other slides
    };
    const [formdata,setFormData]=useState({
        name:'',
        phone:'',
        email:'',
        message:'',
    });
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formdata,
          [name]: value,
        });
      };
      const handlePhoneChange = (value) => {
        setFormData({ ...formdata, contactNumber: value });
      };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try{
        const response = await axios.post('https://zoomautos.co.uk/car', {
            formType: 'Message',
            ...formdata,});
        
        
        console.log('Form submitted successfully:', response.data);
        

        setFormData({
            name:'',
            phone:'',
            email:'',
            message:'',}

        )
        setLoading(false);
    setSuccess(true);
    window.location.reload();
        
}
        catch(error){
            console.error('Error submitting form:', error.response ? error.response.data : error.message);
      
        }

        
    };
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const checkMobile = () => {
        setIsMobile(window.innerWidth <= 768); // Adjust the width based on your requirement
      };
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
  

    const handleButtonClick = () => {
        navigate(`/Inventory`);
    };

    // Display loading state or empty state
    if (loading) {
        return <p>Loading cars...</p>;
    }

    return (
        <div className="sliders-container">
            <Slider ref={sliderRef} {...settings}>
                {/* Slide 1 with video */}
                {!isMobile && !videoPlayed && (
        <div className="image-slide">
          <video
            ref={videoRef}
            className="slide-video"
            autoPlay
            muted
            onEnded={handleVideoEnd}
          >
            <source src="/VideoSource.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      )}
                
                {/* Slide 2 with form */}
                <div className="image-slide">
                    <img src="/Image Home page 1.jpg" alt="Image 2" className="slide-image" />
                    <div className="simage-overlay" />
                    <div className="overlay-text" >
                        <div className="formss" style={{width:'100%'}}>
                            <h2 className={fadeInForm ? 'fade-in' : ''} style={{ textShadow: 'none' }}>Send A Message</h2>
                            <form onSubmit={handleSubmit} className={fadeInForm ? 'fade-in' : ''}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <input type="text" placeholder="Your Name" name="name" value={formdata.name} onChange={handleChange} required />
                                    <input type="text" placeholder="Your Contact Number"  name="phone" value={formdata.phone} onChange={handleChange}  required />
                                    


                                    <input type="email" placeholder="Your Email" name="email" value= {formdata.email} onChange={handleChange} required />
                                    <textarea placeholder="Message" name="message" value= {formdata.message} onChange={handleChange} required></textarea>
                                    <button className="contact-button" type="submit">
                                        SEND MESSAGE
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Slide 3 with filter */}
                <div className="image-slide">
                    <img src="/Image 9.jpg" alt="Image 3" className="slide-image" />
                    <div className="image-overlay" style={{ backdropFilter: 'blur(4px)', background: 'rgba(30, 30, 30, 0.5)'}}>
                        <div className="overlays-texts">
                            <h1 
                                key={`title-${animationKey}`} 
                                className={`heading ${fadeIn ? 'fade-in' : ''}`} 
                                style={{ marginBottom: '20px', color: 'white' }}
                            >
                                Purchase Your Car
                            </h1>

                            <div key={`filter-${animationKey}`} className={fadeInFilter ? 'fade-in-filter' : ''}>
                                <CarFilter
                                    carMakes={carMakes}
                                    carModels={carModels}
                                    carVariants={carVariants}
                                    carColors={carColors}
                                    selectedMake={selectedMake}
                                    selectedModel={selectedModel}
                                    selectedVariant={selectedVariant}
                                    selectedColor={selectedColor}
                                    handleMakeChange={handleMakeChange}
                                    handleModelChange={handleModelChange}
                                    handleVariantChange={handleVariantChange}
                                    setSelectedColor={setSelectedColor}
                                />
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <button style={{ alignSelf: 'flex-end' }} className="contact-button" onClick={handleButtonClick}>
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Add more slides as needed */}
            </Slider>
            {loadings && (
        <div className='overlayStyle'>
          <div className='loadingStyle'  >Submitting...</div>
        </div>
      )}

      {/* Success Overlay */}
      {success && (
        <div className='overlayStyle'>
          <div className='successStyle' >Thank you for contacting us!!!</div>
        </div>
      )}
        </div>
    );
};

export default ImageSlider;
